import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";
import { CandidateResponse, CandidatesView } from "./model/candidates";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const candidatesApi = createApi({
  reducerPath: "candidatesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    // result type = EmployeesView, arg type = string
    getCandidates: builder.query<CandidatesView, string>({
      query: (qs) => `/api/v2/candidates?${qs}`,
      // server returns CandidateResponse; map it to CandidatesView
      transformResponse: (response: CandidateResponse): CandidatesView => ({
        data: response.candidates,
        count: response.meta?.count ?? 0
      })
    })
  })
});

export const { useGetCandidatesQuery } = candidatesApi;
